import { render, staticRenderFns } from "./ArchivedSurveys.vue?vue&type=template&id=1685a4de&"
import script from "./ArchivedSurveys.vue?vue&type=script&lang=js&"
export * from "./ArchivedSurveys.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedSurveys.vue?vue&type=style&index=0&id=1685a4de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports